// FemaleHormoneCard.jsx

import React from "react";
import BasePackageCard from "./BasePackageCard";
import { HORM_F } from "../../../../constants";
import { useTranslation } from "../../../../language";

export default function FemaleHormoneCard() {
  const { t } = useTranslation();

  const panel = {
    id: "hormone_female",
    title: t("card_female_hormone_title"),
    subtitle: t("card_female_hormone_desc"),
    biomarkers: t("card_female_hormone_markers"),
    price: "€ 149",
    image: HORM_F,
  };

  return <BasePackageCard panel={panel} />;
}